import { RUN_MODE } from "framework/RCApp";

export interface AppFlavour {
  pilotId: number
  backendApiUrl: string
  environment : string
}

export class AppFlavour {
  static flavour: AppFlavour;

  constructor() {
    this.pilotId = 10057;
    this.environment = "dev";
    this.backendApiUrl = "bidgelyevuatapi.bidgely.com";
  }

  static getFlavour() {
    if(this.flavour) {
      return this.flavour;
    }
    if(typeof (window) === "undefined") {
      this.flavour = new AppFlavour();
      return this.flavour;
    }

    const host = window.location.host;

    if (FlavourSDGE.isDomainSupported(host)) {
      this.flavour = new FlavourSDGE();
    } else if(FlavourENO.isDomainSupported(host)) {
      this.flavour = new FlavourENO();
    } else if(FlavourPowershift.isDomainSupported(host)) {
      this.flavour = new FlavourPowershift();
    } else if(FlavourAmeren.isDomainSupported(host)) {
      this.flavour = new FlavourAmeren();
    } 
    else {
      this.flavour = new AppFlavour();
    }
    return this.flavour;
  }

  static getEnvironmentFromURL(host : string){
    let environment = RUN_MODE.PROD;
    if(host.includes("-dev")){
      environment = RUN_MODE.PROD;
    } else if(host.includes("-uat")){
      environment = RUN_MODE.UAT;
    } else if(host.includes("-nonprodqa")){
      environment = RUN_MODE.QA;
    } else if(host.includes("-productqa")){
      environment = RUN_MODE.PRODUCT_QA;
    }

    return environment
  }

}

class FlavourSDGE extends AppFlavour {
  constructor() {
    const host = window.location.host;

    super();
    this.pilotId = 10082;
    this.backendApiUrl = "dspidevapi.bidgely.com";
    this.environment = AppFlavour.getEnvironmentFromURL(host);
  }

  static isDomainSupported(host : string) {
    return new RegExp(/^console-sdge(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}
class FlavourENO extends AppFlavour {
  constructor() {
    const host = window.location.host;

    super();
    this.pilotId = 10090;
    this.backendApiUrl = "dspidevapi.bidgely.com";
    this.environment = AppFlavour.getEnvironmentFromURL(host);
  }

  static isDomainSupported(host : string) {
    return new RegExp(/^console-eno(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class FlavourPowershift extends AppFlavour {
  constructor() {
    const host = window.location.host;

    super();
    this.pilotId = 10058;
    this.backendApiUrl = "bidgelyevuatapi.bidgely.com";
    //this.environment = AppFlavour.getEnvironmentFromURL(host);
    this.environment = RUN_MODE.UAT;
  }

  static isDomainSupported(host : string) {
    return new RegExp(/^edison(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class FlavourAmeren extends AppFlavour {
  constructor() {
    const host = window.location.host;

    super();
    this.pilotId = 10057;
    this.backendApiUrl = "herdevapi.bidgely.com";
    this.environment = AppFlavour.getEnvironmentFromURL(host);
  }

  static isDomainSupported(host : string) {
    return new RegExp(/^oreo(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}